// Real catalog products (mirrors ProductsCatalog PRODUCTS) for the homepage
// "change room" teaser. Images are the baked room renders used by the shopping feed.
// "Modern living" (modern-styled-12 / גלריה מודרנית) is shown first by default; the
// rest cycle when "שינוי חדר" is pressed. Each links to its real /products page.
// `pos` = object-position for the 4/5 crop (default center). It slides the WHOLE photo
// (frame-vs-sofa centering is baked in — see e2e/_bake-feed-thumbs.cjs SCENES.cx). Used to
// re-centre a render whose composition sits off-centre after the crop: LOWER X% shows more
// of the image's LEFT, which slides the whole scene RIGHT toward the middle of the card.
const products = [
  { id: 'modern-styled-12', name: 'גלריה מודרנית', count: 12, scene: 'modern-styled', cols: 4, pos: '40% 50%' },
  { id: 'entry-24', name: 'גלריית הכניסה', count: 24, scene: 'entry-balatot', cols: 6, bw: true },
  { id: 'stone-16-diamond', name: 'יהלום ירושלמי', count: 16, scene: 'stone', rows: '1-2-3-4-3-2-1' },
  { id: 'coastal-10', name: 'נוף הים', count: 10, scene: 'coastal', cols: 5 },
  { id: 'kids-blue-10', name: 'חברים קטנים', count: 10, scene: 'kids-blue', cols: 5 },
  { id: 'bedroom-calm-9', name: 'רוגע', count: 9, scene: 'bedroom-calm', cols: 3, bw: true },
  { id: 'village-6', name: 'כפרי חמים', count: 6, scene: 'living', cols: 3 },
  { id: 'study-4', name: 'פינת עבודה', count: 4, scene: 'study', cols: 2 },
].map((p) => ({ ...p, image: `/assets/shopping/feed/${p.id}.jpg` }));

export default products;
